import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Box, IconButton, Typography, Tooltip } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import InfoIcon from "@mui/icons-material/Info";
import _ from "lodash";
import "./Scenario.css";

/*
number 
a/b
infoIcon
title
options = [[optionName, optionIcon], [optionName1, optionIcon1], [optionName2, optionIcon2]]
*/

const theme = createTheme({
 components: {
  MuiTooltip: {
   styleOverrides: {
    tooltip: {
     backgroundColor: "white",
     color: "#151515 ",
     fontSize: "14px",
     fontFamily: "Helvetica, Arial, sans-serif",
     lineHeight: "1.3em",
     boxShadow: "0 1px 2px rgba(0, 0, 0, 0.3)",
     border: "1px solid #ccc",
     padding: "8px",
    },
   },
  },
 },
});

const StormScenario = ({
 number,
 aB,
 title,
 options,
 info,
 scenarioContainerClassname,
 thunk,
 stateKey,
 switchCase,
 btnClick,
 availableKeyName,
 reductionState,
}) => {
 const dispatch = useDispatch();

 // auto-select storm surge options
 useEffect(() => {
  if (
   !!!reductionState["selectedGroundwaterConditions"]
   // && reductionState["selectedRainfallAmount"] !== "100-yr" // it breaks w/out this condition..? Idk why.
  ) {
   // if there is only one option left, auto-select it
   if (
    _.uniqBy(reductionState["availableStormSurges"], stateKey).length === 1
   ) {
    _.uniqBy(reductionState["availableStormSurges"], stateKey).forEach((i) => {
     thunk(i[stateKey], dispatch); // update state
     btnClick(switchCase, i[stateKey]); // "click" the button
    });
   }
  }
 }, [reductionState["availableStormSurges"]]);

 // auto-select gw condition
 useEffect(() => {
  if (!!!reductionState["selectedGroundwaterConditions"]) {
   if (
    _.uniqBy(reductionState["availableGroundwater"], stateKey).length === 1
   ) {
    _.uniqBy(reductionState["availableGroundwater"], stateKey).forEach((i) => {
     thunk(i[stateKey], dispatch); // update state
     btnClick(switchCase, i[stateKey]); // "click" the button
    });
   }
  } else {
   // if gw condition is selected,
   // auto-select adaptation scenario, "None"
   // UPDATE: we only needed to do this when adaptation scenario was the last option in sidebar
   // dispatch(getAdaptationScenario("None"));
   // dispatch(getAdaptationScenario2("None"));
   // btnClick("setSelectedAdaptation", "None");
  }
 }, [reductionState["availableGroundwater"]]);

 return (
  <Box
   sx={{
    visibility: `${title === "Groundwater Conditions" ? "hidden" : "visible"}`,
    height: `${
     title === "Groundwater Conditions" ? "0px" : "calc((100vh - 250px) / 4)"
    }`,
    py: `${title === "Groundwater Conditions" ? "0px" : "12px"}`,
    minHeight: `${title === "Groundwater Conditions" ? "0px" : "116px"}`,
   }}
   className={`${scenarioContainerClassname}`}
  >
   <Box className="scenario-header">
    <Box className="scenario-header-item">
     <Typography variant="h6" className="scenario-title">
      {number}
      {aB}. {title}
     </Typography>
    </Box>
    <div className="scenario-header-item row center-center info">
     <ThemeProvider theme={theme}>
      <Tooltip title={info}>
       <IconButton sx={{ p: "6px" }}>
        <InfoIcon sx={{ color: "white" }} className="info-icon" />
       </IconButton>
      </Tooltip>
     </ThemeProvider>
    </div>
   </Box>

   <div
    className={`${
     stateKey === "adaptationScenario"
      ? "storm-buttons-container-adaptation"
      : "storm-buttons-container"
    }`}
   >
    {stateKey === "adaptationScenario" ? (
     <>
      {options?.map(([optionName, optionIcon], idx) => {
       return (
        <div
         key={`adaptation-scenario-${idx}`}
         className={
          optionName == reductionState["selectedAdaptation"]
           ? `selected-storm-button-${aB}`
           : `storm-button-${aB}`
         }
         onClick={() => {
          thunk(optionName, dispatch);
          btnClick(switchCase, optionName);
         }}
        >
         <Typography
          className="option-name"
          variant="subtitle1"
          component="div"
         >
          {optionName}
         </Typography>
        </div>
       );
      })}
     </>
    ) : (
     <>
      {_.uniqBy(reductionState[availableKeyName], stateKey).map((i) => {
       return (
        <div
         key={`${stateKey}-${i}-${i[stateKey]}`}
         // selected / unselected classnames:
         // selected-storm-button-a, selected-storm-button-b / storm-button-a, storm-button-b
         className={
          i[stateKey] == reductionState["selectedSLR"] &&
          availableKeyName === "availableSLR"
           ? `selected-storm-button-${aB}`
           : i[stateKey] == reductionState["selectedRainfallAmount"] &&
             availableKeyName === "availableRain"
           ? `selected-storm-button-${aB}`
           : i[stateKey] == reductionState["selectedStormSurge"] &&
             availableKeyName === "availableStormSurges"
           ? `selected-storm-button-${aB}`
           : i[stateKey] == reductionState["selectedGroundwaterConditions"] &&
             availableKeyName === "availableGroundwater"
           ? `selected-storm-button-${aB}`
           : `storm-button-${aB}`
         }
         onClick={() => {
          thunk(i[stateKey], dispatch);
          btnClick(switchCase, i[stateKey]);
         }}
        >
         <Typography
          className="option-name"
          variant="subtitle1"
          component="div"
         >
          {`${i[stateKey]}`}
         </Typography>
        </div>
       );
      })}
     </>
    )}
   </div>
  </Box>
 );
};

export default StormScenario;
